export const PRIORITY_COLORS = {
    "Crítica": "danger",
    "Alta": "warning",
    "Média": "info",
    "Baixa": "muted",
};

export const KANBAN_COLUMNS = [
    { key: "open", label: "Aberto" },
    { key: "progress", label: "Em Análise" },
    { key: "resolved", label: "Resolvido" },
];

export const TICKET_FORM_DEFAULTS = {
    title: "",
    idTenant: "",
    tenantName: "",
    category: "Dúvida Geral",
    priority: "Média",
    channel: "whatsapp",
    contactName: "",
    contactPhone: "",
    contactEmail: "",
    description: "",
    assignedToUid: "",
    assignedToName: "",
};

export const TICKET_CATEGORIES = [
    { value: "Dúvida Geral", label: "Dúvida Geral" },
    { value: "Financeiro", label: "Financeiro / Cobrança" },
    { value: "Bug do Sistema", label: "Bug / Erro do Sistema" },
    { value: "Configuração", label: "Configuração / Implantação" },
    { value: "Integração", label: "Integração / API" },
    { value: "Performance", label: "Performance / Lentidão" },
    { value: "Acesso", label: "Acesso / Login" },
    { value: "Solicitação", label: "Solicitação de Funcionalidade" },
    { value: "Cancelamento", label: "Cancelamento / Retenção" },
    { value: "Outro", label: "Outro" },
];

export const TICKET_PRIORITIES = [
    { value: "Crítica", label: "Crítica — Sistema parado" },
    { value: "Alta", label: "Alta — Impacto grande" },
    { value: "Média", label: "Média — Impacto moderado" },
    { value: "Baixa", label: "Baixa — Sem urgência" },
];

export const TICKET_CHANNELS = [
    { value: "whatsapp", label: "WhatsApp" },
    { value: "email", label: "E-mail" },
    { value: "phone", label: "Telefone" },
    { value: "chat", label: "Chat do Sistema" },
    { value: "internal", label: "Abertura Interna" },
];
